export default __webpack_public_path__ + "static/internship-ae55fd96da83c1161c16b650c30c4c76.svg";